import { render, staticRenderFns } from "./EventsWidget.vue?vue&type=template&id=7088f878"
import script from "./EventsWidget.vue?vue&type=script&lang=ts"
export * from "./EventsWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports